export const pdpa = {
    terms_title: 'Terms & Conditions',
    privacy_title: 'Privacy policy',
    mkt_title: 'Marketing message',
    btn_accept: 'Accept',
    allow_channel: 'I am interested in and would like to receive information about products, services, free, gifts, discounts, promotions and other relevant activities from ShopDD and affilliated Buzzebees Co.,Ltd, Please allow us at least 1 channel.',
    checkbox_email: 'Email',
    checkbox_sms: 'SMS',
    mkt_confirm_title: 'If don’t agree marketing consent',
    mkt_confirm_msg: 'You will lose some information and it privilege',
    btn_skip: 'Skip',
    btn_back: 'Back to Setting',
}
